"use strict";
exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map


//////////////////
// WEBPACK FOOTER
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/rxjs/util/isArray.js
// module id = 31
// module chunks = 0 1 2 3 4 5 6 7